import React, { useEffect, useState } from "react";
import { Users, IndianRupee, Layers, TrendingUp, Share2, Sparkles } from "lucide-react";
import { adminApi } from "@/lib/admin";

const inr = (v) => `₹${Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

export default function AdminDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { adminApi.get("/dashboard").then((r) => setD(r.data)); }, []);
  if (!d) return <div className="text-muted-foreground">Loading…</div>;

  return (
    <div className="space-y-8">
      <div>
        <div className="sq-label">Overview</div>
        <h1 className="text-4xl font-heading font-bold mt-1 text-secondary">Platform dashboard</h1>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Stat icon={<Users size={16} />} label="Factories" value={d.total_factories} tid="stat-factories" />
        <Stat icon={<Layers size={16} />} label="Designs" value={d.total_designs} tid="stat-designs" />
        <Stat icon={<IndianRupee size={16} />} label="Quoted value" value={inr(d.total_value)} tid="stat-value" />
        <Stat icon={<TrendingUp size={16} />} label="This month" value={d.month_designs} tid="stat-month" />
        <Stat icon={<Share2 size={16} />} label="Quotes shared" value={d.quotes_shared} tid="stat-shared" />
        <Stat icon={<Layers size={16} />} label="Total quotes" value={d.total_quotes} tid="stat-quotes" />
        <Stat icon={<Sparkles size={16} />} label="AI analyses" value={d.total_ai_analyses ?? 0} tid="stat-ai" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <TopList title="Top garments" items={d.top_garments} />
        <TopList title="Top machine brands" items={d.top_brands} />
        <TopList title="Top fabrics" items={d.top_fabrics} />
      </div>
    </div>
  );
}

function Stat({ icon, label, value, tid }) {
  return (
    <div className="sq-card p-5">
      <div className="flex items-center gap-2 text-muted-foreground">
        {icon}<span className="sq-label">{label}</span>
      </div>
      <div className="sq-stat text-3xl mt-2" data-testid={tid}>{value}</div>
    </div>
  );
}
function TopList({ title, items }) {
  return (
    <div className="sq-card p-5">
      <h3 className="font-heading font-semibold mb-3">{title}</h3>
      {items.length === 0 && <div className="text-muted-foreground text-sm">No data yet.</div>}
      <ul className="space-y-2">
        {items.map((i) => (
          <li key={i.name} className="flex items-center justify-between text-sm">
            <span className="font-medium">{i.name}</span>
            <span className="font-heading font-bold text-primary">{i.count}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
